module.exports = __webpack_public_path__ + "fonts/600-italic-cyrillic.56f45fd.woff2";